import { Link } from "react-router-dom";

function Button({children, onClick, color, to}){
const colorVariants = {
    black: "bg-black hover:bg-lightBlack text-white",
    white: "bg-white hover:bg-darkenWhite text-lightBlack hover:text-black border-[1px] border-lightBlack hover:border-black",
    yellow: "bg-yellow hover:bg-darkenYellow text-lightBlack hover:text-black",
  };

    return(
        <Link 
            to={to}
            className={`${colorVariants[color]} text-[8px] lg:text-[14px] py-[8px] md:py-[12px] px-[8px] md:px-[24px] duration-200 rounded-[8px] lg:rounded-[12px] w-fit`}
            onClick={onClick}>
                {children}
        </Link>
    )
}

export default Button